export default __webpack_public_path__ + "a4dfd616310a20249228433c0e17b2ba.png";